module.exports = __webpack_public_path__ + "img/kekw.eeea9090.png";